export default __webpack_public_path__ + "static/media/u_l.8f555b26.wav";